import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const IncTestEndText = () => {
  const { t } = useTranslation("common");
  return (
    <>
      <Typography variant="h4" sx={{ textAlign: "center", mb: 4 }}>
        {t("inc.end.title")}
      </Typography>
      <Typography variant="body1" sx={{ textAlign: "justify", mb: 4 }}>
        {t("inc.end.text")}
      </Typography>
    </>
  );
};

export default IncTestEndText;
